<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="Activity list">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="flex-wrapper" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <ul class="marketmanage-list">
                <li v-for='item in marketmanageList' v-bind:key='item.marketmanage_id' @click="goMarketmanage(item)">
                    <p>Activity name:{{item.marketmanage_name}}</p>
                    <p>Activity type:{{item.marketmanage_type}}</p>
                    <p>Start time:{{item.marketmanage_begintime}}</p>
                    <p>End time:{{item.marketmanage_endtime}}</p>
                </li>
            </ul>
            <empty-record v-if='marketmanageList.length <= 0 && !isMore'></empty-record>
        </div>
    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import { getMarketmanageList } from '../../../api/homeMarketmanage'
export default {
  name: 'MarketmanageList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      type: this.$route.query.type ? this.$route.query.type : '', // 活动类型
      marketmanageList: [],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  methods: {
    loadMore () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.getMarketmanageList(true)
      }
    },
    getMarketmanageList () {
      Indicator.open()
      getMarketmanageList(this.params, this.type).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        if (this.marketmanageList) {
          this.marketmanageList = this.marketmanageList.concat(res.result.marketmanage_list)
        } else {
          this.marketmanageList = res.result.marketmanage_list
        }
        this.loading = false
      }).catch(error => {
        Indicator.close()
        Toast(error.message)
        this.loading = false
      })
    },
    goMarketmanage (item) {
      if (item.marketmanage_type == 'Scraping card') {
        this.$router.push({ 'name': 'HomeMarketcard', 'query': { 'marketmanage_id': item.marketmanage_id } })
      } else if (item.marketmanage_type == 'Lucky draw') {
        this.$router.push({ 'name': 'HomeMarketwheel', 'query': { 'marketmanage_id': item.marketmanage_id } })
      } else if (item.marketmanage_type == 'Lucky to hit the golden egg') {
        this.$router.push({ 'name': 'HomeMarketegg', 'query': { 'marketmanage_id': item.marketmanage_id } })
      } else {
        this.$router.push({ 'name': 'HomeMarketzodiac', 'query': { 'marketmanage_id': item.marketmanage_id } })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.marketmanage-list li{
                    width:92%;
                    margin:0 2%;
                    padding:.5rem 2%;
                    line-height:1.2rem;
                    height:auto;
                    background:#fff;
                    border-radius: 5px;
                    margin-top: .5rem;
                    border-bottom: 1px dotted #ded6c9;
                    p{
                        font-size:0.65rem;
                    }
}
</style>
